import {useNotify} from 'nvd-u/composables/Notifiy'
import {defineStore} from 'pinia'
// import type { User } from 'src/interfaces/User.interface'
import {useAuthStore} from 'src/stores/auth.store'
// import { useUpgradeStore } from 'src/stores/upgrade.store'
import {FetchRequest} from '../helpers/fetch-request'

export const useTeamStore = defineStore('team', {
    state: () => ({
        req: new FetchRequest('my-team', 'GET'),
        toggleMemberReq: new FetchRequest('update_team', 'POST'),
        addMemberReq: new FetchRequest('add_members', 'POST'),
    }),
    getters: {
        members() {
            const auth = useAuthStore()
            return auth.teamMembers || []
        }
    },
    actions: {
        load() {
            return this.req.send()
        },
        checkMaxMembers() {
            let auth = useAuthStore()
            let numMembers = this.members.filter(m => m.is_member).length
            // if (numMembers < auth.maxTeamMembers) return true
            if (numMembers < 4) return true
            // showModal('maxMembers')
            return false
        },
        async toggleMembership(user) {
            let auth = useAuthStore()

            if (user.id === auth.user.id) return // cant toggle the owner

            if (!user.is_team && !this.checkMaxMembers()) return


            const request = this.toggleMemberReq
            try {
                const response: any = await request.send({
                    body: JSON.stringify({ref_id: user.ref_id})
                })
                if (this.toggleMemberReq !== request) return false
                Object.assign(user, response.member)
                useNotify().success('Success', user.is_team ? 'Member added' : 'Member removed')
                await auth.reFetchUser()
                return true
            } catch (error) {
                return false
            }
        },
    },
})
